<template>
<div class="containers mt-3 p-4">
    <CRow>
      <CCol sm="12">
        <h5 style="color:black">Tracing COVID-19</h5>
        <hr class="mt-2 mb-4"/>
      </CCol>
    </CRow>
    <CRow class="mb-4 mt-2">
        <CCol sm="1"></CCol>
        <CCol sm="5 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Pegawai Positif/Reaktif</div>
                    <div class="card-subtitle">Data pegawai per hari ini yang positif/reaktif</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-6">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;cursor:pointer" class="text-left">{{totalReaktif}}</span>
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="5 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Total Kontak Erat</div>
                    <div class="card-subtitle">Data pegawai yang hari ini kontak erat</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-6">
                        <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;cursor:pointer" class="text-left">{{totalKontakErat}}</span>
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="1"></CCol>
    </CRow>
    <CRow>
      <CCol xs="12" lg="12" class="bgTab">
          <CCardBody class="p-0 pb-3 pt-3">
            <CTabs add-tab-classes="mt-1">
              <CTab @click.native="changeTab(1)">
                <template slot="title">
                  {{tabs[0]}}
                </template>
              </CTab>
              <CTab @click.native="changeTab(2)">
                <template slot="title">
                  {{tabs[1]}}
                </template>
              </CTab>
              <CTab @click.native="changeTab(3)">
                <template slot="title">
                  {{tabs[2]}}
                </template>
              </CTab>
            </CTabs>
          </CCardBody>
      </CCol>
    </CRow>
    <CRow v-if="tab == '1'" class="mt-3">
        <CCol sm="12">
            <div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
                <div class="row">
                    <div class="col-12 text-left">
                        <h4 class="card-title mb-0">Daftar Reaktif</h4>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-1">
                        <hr class="border-primary"/> 
                    </div>
                    <div class="col-md-11">
                        <hr/>
                    </div>
                </div>
                <DaftarHasil @change="changeValue"/>
            </div>
        </CCol>
    </CRow>
    <CRow v-if="tab == '2'" class="mt-3">
        <CCol sm="12">
            <div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
                <div class="row">
                    <div class="col-12 text-left">
                        <h4 class="card-title mb-0">Detail Reaktif Unit</h4>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-1">
                        <hr class="border-primary"/> 
                    </div>
                    <div class="col-md-11">
                        <hr/>
                    </div>
                </div>
                <DetailHasilTes />
            </div>
        </CCol>
    </CRow>
    <CRow v-if="tab == '3'" class="mt-3">
        <CCol sm="12">
            <div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
                <div class="row">
                    <div class="col-12 text-left">
                        <h4 class="card-title mb-0">Riwayat Tes Massal</h4>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-1">
                        <hr class="border-primary"/> 
                    </div>
                    <div class="col-md-11">
                        <hr/>
                    </div>
                </div>
                <DaftarRiwayat />
            </div>
        </CCol>
    </CRow>
</div>
</template>
<script>
import DaftarHasil from './DaftarHasil.vue'
import DetailHasilTes from './DetailHasilTes.vue'
import DaftarRiwayat from './DaftarRiwayat.vue'
import {DataApi} from "../../../service/DataApi";

export default {
    components: {
        DaftarHasil,
        DetailHasilTes,
        DaftarRiwayat
    },
    data() {
        return {
            tab: 1,
            activeTab: 1,
            tabs: [
                'Daftar Reaktif',
                'Detail Reaktif Unit',
                'Riwayat Tes Massal'
            ],
            totalReaktif: '0',
            totalKontakErat: '0'
        }
    },
    methods: {
        changeTab(val){
            this.tab = val
            this.activeTab = val
        },
        getDataSummary() {
            this.$store.state.loadingScreen = true
            DataApi.get("rta/rekap/summary/lihat")
            .then( res => {
                let response = res.data
                if(response.success == true) {
                    this.totalReaktif = response.data.totalReaktif
                    this.totalKontakErat = response.data.totalKontakErat
                } else {
                    this.totalReaktif = '0'
                    this.totalKontakErat = '0'
                }
                this.$store.state.loadingScreen = false
            })
        },
        changeValue() {
            this.getDataSummary()
        }
    },
    mounted() {
        this.getDataSummary()
    },
}
</script>

<style scoped>
.bgTab{
  background-color: rgba(249, 250, 252, 1);
}
.page-title{
  padding: 20px 40px 15px 40px;
}
::v-deep .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  /* border-color: ; */
  font-weight: bold;
  color: rgba(21, 100, 153, 1);
  border-bottom: 3px solid rgba(21, 100, 153, 1) !important;
  background-color: transparent;
}
::v-deep .nav-tabs .nav-item {
  border: none !important;
  border-bottom: 1px solid gainsboro;
}

::v-deep .nav-tabs .nav-link {
 padding: 14px;
 background-color: rgba(249, 250, 252, 1);
 border-bottom: 1px solid gainsboro;
}
::v-deep .nav-item a {
  color: rgba(154, 154, 154, 1);
}
::v-deep .nav-item {
  border-bottom: 1px solid gainsboro;
}
::v-deep .nav-item {
  font-weight: bold!important;
  color: #606060;
  background-color: rgba(249, 250, 252, 1);
  width: 25%;
  text-align: center;
}
.card-title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
</style>